import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-error-dialog',
  template: `
    <div class="error-dialog">
      <p [innerHtml]="error"></p>
      @if (!overrideButtonKey) {
        <button mat-button class="wide-button" color="warn" (click)="dialogRef.close()">
          {{ 'BUTTONS.CLOSE' | translate }}
        </button>
      }
      @if (!!overrideButtonKey) {
        <button mat-button class="wide-button" color="warn" (click)="dialogRef.close()">
          {{ overrideButtonKey | translate }}
        </button>
      }
    </div>
    `,
  styles: [
    `
      .error-dialog {
        height: 100px;
        padding: 5px;
      }
      .wide-button {
        margin: 0 auto;
        display: block;
        height: 40px;
        line-height: 40px;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ErrorDialogComponent {
  error: string;
  public overrideButtonKey: string;

  constructor(
    public dialogRef: MatDialogRef<ErrorDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.error = data.errMsg;
    this.overrideButtonKey = data.overrideButtonKey ? data.overrideButtonKey : '';
  }
}
